import * as React from "react";
import { cn } from "../../../lib/utils";
import { Card } from "../card";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from "../table";

function DataTableCard({
  className,
  tableClassName,
  headerClassName,
  columns,
  children,
  emptyMessage,
  isEmpty,
  minWidth = "640px",
}) {
  return (
    <Card variant="table" padding="none" className={className}>
      <div className="overflow-x-auto [-webkit-overflow-scrolling:touch]">
        <Table
          className={cn(tableClassName)}
          style={{ minWidth }}
        >
          {columns && (
            <TableHeader className={cn("bg-slate-50", headerClassName)}>
              <TableRow className="hover:bg-transparent">
                {columns.map((col) => (
                  <TableHead key={col.key ?? col} className={col.className}>
                    {col.label ?? col}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
          )}
          <TableBody>
            {isEmpty ? (
              <TableRow className="hover:bg-transparent">
                <TableCell
                  colSpan={columns?.length ?? 1}
                  className="py-12 text-center text-[#a0aec0]"
                >
                  {emptyMessage ?? "داده‌ای یافت نشد"}
                </TableCell>
              </TableRow>
            ) : (
              children
            )}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}

export {
  DataTableCard,
  TableRow as DataTableRow,
  TableCell as DataTableCell,
};
